<label class="radio-container" [attr.for]="inputId">
  <input
    type="radio"
    [id]="inputId"
    [attr.name]="nameAttr"
    [attr.aria-checked]="isChecked ? 'true' : 'false'"
    [checked]="isChecked"
    [disabled]="isDisabled"
    (change)="onNativeChange($event)"
  />
  <span class="radio-button"></span>
  <ng-content></ng-content>
</label>
